import React from 'react';
import {connect} from 'react-redux'
import compose from 'recompose/compose';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { FormControlLabel, FormGroup,  Grid, TextField } from '@material-ui/core';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import {DatePicker} from 'material-ui-pickers';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import MenuItem from '@material-ui/core/MenuItem';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import License from './licenseVehicle';
import Paper from '@material-ui/core/Paper';
import InputVirtual from 'components/InputVirtual'
import Backup from '@material-ui/icons/Backup';
import SweetAlert from 'react-bootstrap-sweetalert';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';

import {Card, CardBody, CardImg, CardSubtitle, CardText} from 'reactstrap';

import {BASE_URL_APIv5, BASE_HEADER, FILE_HEADER, BASE_URL_API} from "constants/ActionTypes";

const companyId = localStorage.getItem('companyId')
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

const COMPANY_ID = localStorage.getItem('companyId')

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const fuelType = [
    'Bio Solar',
    'Premium',
    'Pertalite',
    'Pertamax',
    'Solar'
  ];


  function getSteps() {
    return ['Information', 'Engine', 'Measurement', 'Dimension', 'Etc.', 'Document'];
  }


function TabContainer({ children, dir }) {
    return (
      <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
        {children}
      </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
  };
  
  const styles = theme => ({
    root: {
      backgroundColor: theme.palette.background.paper,
      width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    menu: {
        width: 200,
    },
  });


const initialState = {
    bbm_volt_min: 0,
    begin_odo: 0,
    // cc: '',
    chasis_no: '',
    color: '',
    current_odo: 0,
    description: '',
    engine_no: '',
    fuel_capacity: 0,
    fuel_ratio_km: 0,
    fuel_ratio_litre: 0,
    fuel_type: '',
    // helper_id: '',
    // insurance_date: moment(),
    // insurance_no: '',
    is_maintenance: false,
    tank_capacity: 0,
    // last_date_service: moment(),
    // last_date_service2: moment(),
    // last_date_tire: moment(),
    manufactur: '',
    merk: '',
    model: '',
    name: '',
    purchase_date: moment(),
    purchase_from: '',
    purchase_price: 0,
    // route_color: '',
    // selling_date: moment(),
    // selling_price: 0,
    status: false,
    // tank_made_year: '',
    // waranty_date: moment(),
    // waranty_distance: 0,
    year: '',
    company: COMPANY_ID,
    pool: 0,
    vehicle_type: 0,
    bbm_volt_max: 0,
    license_plate: '',
    // total_distance: 0,
    // assembly_type: '',
    axle_weight: 0,
    body_type: '',
    // laden_weight: 0,
    manufacturing_date: moment(),
    seat_capacity: 0,
    // unladen_weight: 0,
    // asset_status_id: 0,
    height_dimension: 0,
    idle_time: 0,
    length_dimension: 0,
    max_speed: 0,
    min_speed: 0,
    width_dimension: 0,
    // driver_id: 0,
    vendor: 0,
    driver: 0,
    // is_vendor: false,
    is_disposed: false,
    is_written_off: false,

    value: 0,

    // Document
    licenseData: [],
    vehicle_license_id: 0,
    license_name: '',
    license_no: '',
    license_exp_date: moment(),
    photo: null,
    image: '',

    errorBodyName: false,
    messageBodyName: '',

    isParentClick: false,
    openDialog: false,
    openSnack: false,
    sweetWarning: false,
    sweetSuccess: false,
    messageSnack: '',

    imageDialog: false,
    urlFrontImage: '',
    urlBackImage: '',
    front_photo_license: null,
    back_photo_license: null,
    front_image_license: null,
    back_image_license: null,
}

class DialogAdd extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.showDialog = this.showDialog.bind(this);
    }
  
  state = initialState

  showDialog() {    
    this.setState({ isParentClick : true });
  };

  componentDidMount() {
    this.props.showDialog(this.showDialog);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.isParentClick == true){
        
            this.setState({
                openDialog: true  // tambahin untuk open dialog state
            })

            this.setState({
                isParentClick : false
            })
        
    }
  }

  getPhoto= event => {
    this.setState({
        photo: event.target.files[0],
        image: URL.createObjectURL(event.target.files[0])
    })

    // console.log(URL.createObjectURL(event.target.files[0]))
 }

    getFrontPhotoLicense = event => {
        this.setState({
            front_photo_license: event.target.files[0],
            front_image_license: URL.createObjectURL(event.target.files[0])
        })

        // console.log(URL.createObjectURL(event.target.files[0]))
    }

    getBackPhotoLicense = event => {
            this.setState({
                back_photo_license: event.target.files[0],
                back_image_license: URL.createObjectURL(event.target.files[0])
            })

            // console.log(URL.createObjectURL(event.target.files[0]))
    }

  handleGetCompany = ({id}) => {
    // console.log(id)
    this.setState({company: id})    
  }

  handleGetPool = ({id}) => {
    // console.log(id)
    this.setState({pool: id})    
  }

  handleGetVehicleType = ({id}) => {
    // console.log(id)
    this.setState({vehicle_type: id})    
  }

  handleGetVendor= ({id}) => {
    // console.log(id)
    this.setState({vendor: id})    
  }

  handleGetDriver= ({id}) => {
    // console.log(id)
    this.setState({driver: id})    
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  handleChangeSwitch = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleDateKir = (date) => {
    this.setState({kirDate: date});
  };

  handleDateKiu = (date) => {
    this.setState({kiuDate: date});
  };

  handleDateIbm = (date) => {
    this.setState({ibmDate: date});
  };

  handleDateStnk = (date) => {
    this.setState({stnkExpDate: date});
  };

  handleChangeBodyName = (e) => {
      const str = e.target.value
      if(str.length === 0){
        this.setState({errorBodyName: true, messageBodyName: 'Field cannot be empty'})
      } else if (str.length < 4) {
        this.setState({errorBodyName: true, messageBodyName: 'Field must be more than 3 character'})
      } else {
          // console.log('success')
        this.setState({errorBodyName: false, name: str})
      }
  }

  getInputVehicleLicense = (data) => {
    // console.log(data)
    if(data !== null){
        this.setState({vehicle_license_id: data.id, license_name: data.license_name})
    } else {
        this.setState({vehicle_license_id: 0, license_name: ''})
    }
    
  }

  getInputFuelType = (data) => {
    // console.log(data)
    if(data !== null){
        this.setState({fuelType: data.name})
    } else {
        this.setState({fuelType: ''})
    }
    
  }

  handleAddLicenseVehicle = (param) => {
    const {vehicle_license_id, license_name, license_exp_date, license_no, licenseData, photo, front_image_license, back_image_license, front_photo_license, back_photo_license} = this.state
    const licenseDate = license_exp_date.format("YYYY-MM-DD")

    if(param === 'edit'){
        if(license_name !== '' || license_no !== ''){
          const obj = {
              license_name, 
              vehicle_license: vehicle_license_id,
              license_exp_date: licenseDate,
              license_no,
              data_front_photo: front_photo_license,
              data_back_photo: back_photo_license,
              front_photo: front_image_license,
              back_photo: back_image_license
            }
          this.setState({openSnack: true, messageSnack: 'Add License Success', licenseData: [...licenseData, obj]})
          // console.log(licenseData)
        } else {
          this.setState({openSnack: true, messageSnack: 'Please Insert data correctly'})
        }
    }

    this.setState({
        license_name: '',
        license_exp_date: moment(),
        license_no: '',
        photo: null,
        image: null,
        front_photo_license: null,
        back_photo_license: null,
        front_image_license: null,
        back_image_license: null
    })
  }

  handleChangeFrontPhotoLicense = async (id, data) => {
    const {vehicle_license, data_front_photo } = data
    
    const formData = new FormData()
    formData.append(
      'file',
      data_front_photo,
      data_front_photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_APIv5}/vehicle-license-detail/change-front-photo/${id}/${vehicle_license}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }
  
  handleChangeBackPhotoLicense = async (id, data) => {
    const {vehicle_license, data_back_photo } = data
    
    const formData = new FormData()
    formData.append(
      'file',
      data_back_photo,
      data_back_photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_APIv5}/vehicle-license-detail/change-back-photo/${id}/${vehicle_license}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }

  handleImageLicense = data => {
    // console.log(data)
    this.setState({
        imageDialog: true,
        urlFrontImage: data.front_photo,
        urlBackImage: data.back_photo
    })
  }

  handleUploadLicenseImage = id => {
    const {licenseData} = this.state
    // console.log(licenseData)
    licenseData.map(async res => {
        if(res.data_front_photo !== null){
            const result2 = await this.handleChangeFrontPhotoLicense(id, res)
            // console.log(result2)
            if(result2.data.status !== true){
                NotificationManager.error(result.data.message, 'Error message')
                return false
            }
        }
    
        if(res.data_back_photo !== null){
            const result2 = await this.handleChangeBackPhotoLicense(id, res)
            // console.log(result2)
            if(result2.data.status !== true){
                NotificationManager.error(result.data.message, 'Error message')
                return false
            }
        }
    })
    
  }

  handleRemoveLicense = (data) => {
    const {licenseData} = this.state
    const idx = licenseData.indexOf(data)
    this.setState({sweetWarning: true, idxLicense: idx})
  }

  handleDelete = async param => {
    if(param === 'cancel'){
        // console.log(param)
        this.setState({
            sweetWarning: false,
        })
    } else if (param === 'delete') {
        const {licenseData, idxLicense}  = this.state
        const arr = JSON.parse(JSON.stringify(licenseData));
        arr.splice(idxLicense, 1)
        this.setState({licenseData: arr, sweetWarning: false, sweetSuccess: true})
        // console.log(licenseData)
    }
  }

  handleAddNewVehicle = async data => {
    let obj = JSON.stringify(data)
    const url = `${BASE_URL_APIv5}/vehicle/new`
    const result = await axios.post(url, obj, config).then(res => res).catch(error => error.response)
    return result
  }

  handleChangePhoto = async (id) => {
    const {photo} = this.state
    
    const formData = new FormData()
    formData.append(
      'file',
      photo,
      photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_APIv5}/vehicle/uploadfile/${id}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }


  handleSave = async param => {
    const {
        bbm_volt_min, begin_odo, chasis_no, color, current_odo, description, engine_no, is_written_off,
        fuel_capacity, fuel_ratio_km, fuel_ratio_litre, fuel_type, is_maintenance, tank_capacity,
        merk, model, name, purchase_date, purchase_from, purchase_price, status, year, company,
        pool, vehicle_type, driver, bbm_volt_max, license_plate, axle_weight, body_type, manufacturing_date,
        seat_capacity, height_dimension, idle_time, length_dimension, max_speed, min_speed, width_dimension,
        vendor, is_disposed, vehicle_license,
        ibmDate, kirDate, kiuDate, stnkExpDate,
    } = this.state


    if(param === 'cancel'){
        this.setState(initialState)
        // this.props.handleClose(param)
    } else if (param === 'add') {
        // console.log(param)
        const obj = {
            bbm_volt_min: parseInt(bbm_volt_min),
            begin_odo: parseInt(begin_odo),
            chasis_no, 
            color, 
            current_odo: parseInt(current_odo), 
            description, 
            engine_no, 
            is_written_off,
            fuel_capacity: parseInt(fuel_capacity), 
            fuel_ratio_km: parseInt(fuel_ratio_km), 
            fuel_ratio_litre: parseInt(fuel_ratio_litre), 
            fuel_type, 
            is_maintenance, 
            tank_capacity: parseInt(tank_capacity),
            merk, 
            model, 
            name, 
            purchase_date: purchase_date.format('YYYY-MM-DD'), 
            purchase_from, 
            purchase_price: parseInt(purchase_price), 
            status, 
            year, 
            company: parseInt(company),
            pool, 
            vehicle_type, 
            bbm_volt_max: parseInt(bbm_volt_max), 
            license_plate, 
            axle_weight: parseInt(axle_weight), 
            body_type, 
            manufacturing_date: manufacturing_date.format('YYYY-MM-DD'),
            seat_capacity: parseInt(seat_capacity), 
            height_dimension: parseInt(height_dimension), 
            idle_time: parseInt(idle_time), 
            length_dimension: parseInt(length_dimension), 
            max_speed: parseInt(max_speed), 
            min_speed: parseInt(min_speed), 
            width_dimension: parseInt(width_dimension),
            vendor,
            driver: parseInt(driver), 
            is_disposed,
            vehicle_license: this.state.licenseData,
    
            last_date_service: "2019-01-06",
            last_date_service2: "2019-01-06",
            last_date_tire: "2019-01-06",
            is_vendor: false,
            cc: "100",
            helper: driver.toString(),
            insurance_date: "2019-01-06",
            insurance_no: "test aja",
            route_color: "BC",
            selling_date: "2019-01-06",
            selling_price: 10000,
            tank_made_year: "2019",
            waranty_date: "2019-01-06",
            waranty_distance: 123,
            unladen_weight: 100,
            assembly_type: "dsfdsf",
            asset_status: 1,
        }
        // console.log(obj)
        const result = await this.handleAddNewVehicle(obj)
        // console.log(result)
        if(result.data.status === true){
            if(this.state.photo !== null){
                const result2 = await this.handleChangePhoto(result.data.data.id)
                // console.log(result2)
                if(result2.data.status !== true){
                    NotificationManager.error(result.data.message, 'Error message')
                    return false
                }
            }

            this.handleUploadLicenseImage(result.data.data.id)
            
            NotificationManager.success('Add Vehicle Success', 'Success message')
            this.props.closeDialog(param)
            this.setState(initialState)
           
        } else {
            NotificationManager.error(result.data.message, 'Success message')
        }
    }
    // // console.log(JSON.stringify(obj))
    
  }
  

  render() {
    const {classes, theme} = this.props;
    const {company} = this.state
    const { errorBodyName, messageBodyName } = this.state;
    const textError = false
    const id_company = company !== null ? company : 0
    const filter = [
        {
            name:"company_id",
            "logic_operator":"=",
            value: id_company.toString(),
            "operator":"AND"
        }
    ]
    
      return (
            <div>
                <SweetAlert show={this.state.sweetSuccess} success title='Success' onConfirm={() => this.setState({sweetSuccess: false})}>
                    License was successfully deleted !
                </SweetAlert>
                <SweetAlert show={this.state.sweetWarning}
                            warning
                            showCancel
                            confirmBtnText='Yes Delete!'
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="default"
                            title='Are You Sure?'
                            onConfirm={() => this.handleDelete('delete')}
                            onCancel={() => this.handleDelete('cancel')}
                >
                    You want to delete this License!
                </SweetAlert>
                <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={this.state.openSnack}
                autoHideDuration={3000}
                onClose={() => this.setState({openSnack: false})}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{this.state.messageSnack}</span>}
                action={[
                    <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={() => this.setState({openSnack: false})}
                    >
                    <CloseIcon />
                    </IconButton>
                ]}
                />
                <Dialog
                fullScreen
                open={this.state.openDialog} 
                onClose={() => this.handleSave('cancel')}
                TransitionComponent={Transition}>
                <AppBar className="position-relative">
                    <Toolbar>
                        
                        <Typography type="title" color="inherit" style={{
                            flex: 20,
                        }}>
                            Master Vehicle
                        </Typography>
                        <Button color="inherit" onClick={() => this.handleSave('cancel')}>
                           cancel
                        </Button>&nbsp;&nbsp;
                        <Button color="inherit" onClick={() => this.handleSave('add')}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                <div style={{padding: 40}}>
                    <div className={classes.root}>
                    <AppBar position="static" color="default">
                        <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                        >
                        <Tab label="Information" />
                        <Tab label="Engine" />
                        <Tab label="Measurement" />
                        <Tab label="Dimension" />
                        <Tab label="Document" />
                        <Tab label="Etc." />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={this.state.value}
                        onChangeIndex={this.handleChangeIndex}
                    >
                        <TabContainer dir={theme.direction}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <InputVirtual 
                                        required
                                        label="Company"
                                        value=""
                                        name="name"
                                        secondField=""
                                        lengthData={20}
                                        url={BASE_URL_APIv5+"/company/search"}
                                        setData={[{name:"id",value: this.state.company.toString(),"logic_operator":"=","operator":"AND"}]}
                                        getData={this.handleGetCompany}
                                        fullWidth={true}
                                    />
                                    <InputVirtual
                                        required 
                                        label="Pool"
                                        value=""
                                        name="name"
                                        secondField=""
                                        lengthData={20}
                                        url={BASE_URL_APIv5+"/pool/search"}
                                        filter={filter}
                                        getData={this.handleGetPool}
                                        fullWidth={true}
                                    />
                                    <InputVirtual
                                        required
                                        label="Vehicle Type"
                                        value=""
                                        name="name"
                                        secondField=""
                                        lengthData={20}
                                        filter={filter}
                                        url={BASE_URL_APIv5+"/vehicle-type/search"}
                                        getData={this.handleGetVehicleType}
                                        fullWidth={true}
                                        dialogForm="DialogFormVehicleType"
                                    />
                                    <InputVirtual 
                                        label="Vendor"
                                        value=""
                                        name="name"
                                        lengthData={20}
                                        filter={filter}
                                        url={BASE_URL_APIv5+"/vendor/search"}
                                        getData={this.handleGetVendor}
                                        fullWidth={true}
                                        secondField=""
                                        dialogForm="DialogFormVendor"
                                    />
                                    {/* <InputVirtual 
                                        label="Driver"
                                        value=""
                                        name="name"
                                        secondField=""
                                        lengthData={20}
                                        filter={filter}
                                        url={BASE_URL_APIv5+"/driver/search"}
                                        getData={this.handleGetDriver}
                                        fullWidth={true}
                                    /> */}
                                    <TextField
                                        error={errorBodyName}
                                        required
                                        id="bodyName"
                                        label="Body Name"
                                        type="text"
                                        onChange={this.handleChangeBodyName}
                                        fullWidth
                                    />
                                    {errorBodyName && <FormHelperText error={errorBodyName} id="component-error-text">{messageBodyName}</FormHelperText>}
                                    <FormControlLabel
                                        control={
                                            <Switch
                                            checked={this.state.is_disposed}
                                            onChange={this.handleChangeSwitch('is_disposed')}
                                            value="is_disposed"
                                            color="primary"
                                            disabled
                                            />
                                        }
                                        label="Disposed"
                                    />
                                    <FormControlLabel
                                        style={{marginLeft: '3%'}}
                                        control={
                                            <Switch
                                            checked={this.state.is_written_off}
                                            onChange={this.handleChangeSwitch('is_written_off')}
                                            value="is_written_off"
                                            color="primary"
                                            disabled
                                            />
                                        }
                                        label="Writte Off"
                                    />
                                    
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        required
                    
                                        id="plate_number"
                                        label="Plate Number"
                                        type="text"
                                        onChange={(e) => this.setState({license_plate: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="merk"
                                        label="Merk"
                                        type="text"
                                        onChange={(e) => this.setState({merk: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="model"
                                        label="Model"
                                        type="text"
                                        onChange={(e) => this.setState({model: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="year"
                                        label="Year"
                                        type="text"
                                        onChange={(e) => this.setState({year: e.target.value})}
                                        fullWidth
                                    />
                                    <FormControlLabel
                                        required
                                        control={
                                            <Switch
                                            checked={this.state.status}
                                            onChange={this.handleChangeSwitch('status')}
                                            value="status"
                                            color="primary"
                                            />
                                        }
                                        label="Status"
                                    />
                                    {textError && <FormHelperText error={textError} id="component-error-text">Error</FormHelperText>}
                                    <FormControlLabel
                                        control={
                                            <Switch
                                            checked={this.state.is_maintenance}
                                            onChange={this.handleChangeSwitch('is_maintenance')}
                                            value="is_maintenance"
                                            color="primary"
                                            disabled
                                            />
                                        }
                                        label="Maintenance"
                                    />
                                    <Grid container spacing={24}>
                                        <Grid item xs={6}>
                                        <Paper className={classes.paper} elevation={1}>
                                            <img width="100%" height="150" src={this.state.image !== '' ? this.state.image : 'https://via.placeholder.com/150x150'} style={{
                                                borderRadius: 5,
                                                boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                            }} />
                                        </Paper><br/>
                                            <input 
                                                onChange={this.getPhoto} 
                                                style={{display: 'none'}} 
                                                type="file"
                                                ref={fileInputFront => this.fileInputFront = fileInputFront} />
                                            <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputFront.click()}>
                                                <Backup /> &nbsp;&nbsp;
                                                <span>Upload Photo</span>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                       
                                </Grid>
                            </Grid>

                        
                        </TabContainer>
                        <TabContainer dir={theme.direction}>
                        <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="cylinder"
                                        label="Cylinder"
                                        type="number"
                                        onChange={(e) => this.setState({tank_capacity: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="engine_no"
                                        label="Engine No"
                                        type="text"
                                        onChange={(e) => this.setState({engine_no: e.target.value})}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="fuel_capacity"
                                        label="Fuel Capacity"
                                        type="number"
                                        onChange={(e) => this.setState({fuel_capacity: e.target.value})}
                                        fullWidth
                                    />
                                    <InputVirtual 
                                        label="Fuel Type"
                                        value=""
                                        name="name"
                                        lengthData={20}
                                        url={BASE_URL_APIv5+"/fuel-price/search"}
                                        getData={this.getInputFuelType}
                                        fullWidth={true}
                                        dialogForm="DialogFormVehicleLicense"
                                    />
                                </Grid>
                            </Grid>
                        </TabContainer>
                        <TabContainer dir={theme.direction}>
                                <Grid container spacing={32}>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="begin_odo"
                                        label="Begin ODO"
                                        type="number"
                                        onChange={(e) => this.setState({begin_odo: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">km</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                                        disabled
                                        id="mileage"
                                        label="Mileage"
                                        type="number"
                                        onChange={(e) => this.setState({nameDriver: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">m</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                                        disabled
                                        id="current_odo"
                                        label="Current ODO"
                                        type="number"
                                        onChange={(e) => this.setState({current_odo: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">m</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="fuel_ratio_litre"
                                        label="Fuel Ratio Litre"
                                        type="number"
                                        onChange={(e) => this.setState({fuel_ratio_litre: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">L</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="fuel_ratio_km"
                                        label="Fuel Ration Km"
                                        type="number"
                                        onChange={(e) => this.setState({fuel_ratio_km: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">km</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="bbm_volt_min"
                                        label="BBM Volt Min"
                                        type="number"
                                        onChange={(e) => this.setState({bbm_volt_min: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">v</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="bbm_volt_max"
                                        label="BBM Volt Max"
                                        type="number"
                                        onChange={(e) => this.setState({bbm_volt_max: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">v</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    
                                </Grid>
                            </Grid>
                        </TabContainer>
                        <TabContainer dir={theme.direction}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="length_dimension"
                                        label="Length Box Dimension"
                                        type="number"
                                        onChange={(e) => this.setState({length_dimension: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">cm</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="width_dimension"
                                        label="Width Box Dimension"
                                        type="number"
                                        onChange={(e) => this.setState({width_dimension: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">cm</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="height_dimension"
                                        label="Height Box Dimension"
                                        type="number"
                                        onChange={(e) => this.setState({height_dimension: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">cm</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </TabContainer>
                        <TabContainer dir={theme.direction}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>

                                            <InputVirtual 
                                                label="License Type"
                                                value=""
                                                name="license_name"
                                                lengthData={20}
                                                url={BASE_URL_APIv5+"/vehicle-license/search"}
                                                getData={this.getInputVehicleLicense}
                                                fullWidth={true}
                                                dialogForm="DialogFormVehicleLicense"
                                            />
                                            <DatePicker
                                                fullWidth
                                                clearable
                                                label="Expire Date"
                                                value={this.state.license_exp_date}
                                                format="MMMM Do YYYY"
                                                onChange={(date) => this.setState({license_exp_date: date})}
                                                animateYearScrolling={false}
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                            />
                                            <TextField
                            
                                                margin="dense"
                                                id="license_no"
                                                label="License Number"
                                                type="text"
                                                value={this.state.license_no}
                                                onChange={(e) => this.setState({license_no: e.target.value})}
                                                fullWidth
                                            /><br/><br/>
                                            <Grid container spacing={24}>
                                                <Grid item xs={6}>
                                                    <br/>
                                                    <Paper className={classes.paper} elevation={1}>
                                                        <img width="100%" height="150" src={this.state.front_image_license !== null ? this.state.front_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                            borderRadius: 5,
                                                            boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                                        }} />
                                                    </Paper><br/>
                                                    <input 
                                                        onChange={this.getFrontPhotoLicense} 
                                                        style={{display: 'none'}} 
                                                        type="file"
                                                        ref={fileInputFrontLicense => this.fileInputFrontLicense = fileInputFrontLicense} />
                                                    <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputFrontLicense.click()}>
                                                        <Backup /> &nbsp;&nbsp;
                                                        <span>Upload Front Photo</span>
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={6}>
                                                <br/>
                                                    <Paper className={classes.paper} elevation={1}>
                                                        <img width="100%" height="150" src={this.state.back_image_license !== null ? this.state.back_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                            borderRadius: 5,
                                                            boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                                        }} />
                                                    </Paper><br/>
                                                    <input 
                                                        onChange={this.getBackPhotoLicense} 
                                                        style={{display: 'none'}} 
                                                        type="file"
                                                        ref={fileInputBackLicense => this.fileInputBackLicense = fileInputBackLicense} />
                                                    <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputBackLicense.click()}>
                                                        <Backup /> &nbsp;&nbsp;
                                                        <span>Upload Back Photo</span>
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <br/><br/>
                                        <Button size="small" onClick={() => this.handleAddLicenseVehicle('cancel')}>
                                            Cancel
                                        </Button>
                                        <Button size="small" color="primary" onClick={() => this.handleAddLicenseVehicle('edit')}>
                                            Save
                                        </Button>
                                    
                                </Grid>
                                <Grid item xs={6}>
                            
                                    <Typography variant="h6" gutterBottom style={{marginLeft: 20}}>
                                        <i className="zmdi zmdi-assignment"></i>&nbsp; List Vehicle License
                                    </Typography>
                                    <Divider/>
                                    <Dialog
                                        fullWidth="true"
                                        maxWidth="sm"
                                        open={this.state.imageDialog}
                                        onClose={() => this.setState({imageDialog: false})}
                                        TransitionComponent={Transition}
                                        keepMounted
                                        aria-labelledby="alert-dialog-slide-title"
                                        aria-describedby="alert-dialog-slide-description"
                                    >
                                        <DialogTitle id="max-width-dialog-title">Image License</DialogTitle>
                                        <DialogContent>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Card className="shadow border-0">
                                                            <CardImg top width="100%" src={this.state.urlFrontImage} alt="Card image cap" />
                                                            <CardBody>
                                                                <h3 className="card-title">Front Image</h3>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Card className="shadow border-0">
                                                            <CardImg top width="100%" src={this.state.urlBackImage} alt="Card image cap" />
                                                            <CardBody>
                                                                <h3 className="card-title">Back Image</h3>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                </div>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button variant="contained" className="bg-white text-black" onClick={() => this.setState({imageDialog: false})}>
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    {this.state.licenseData.length > 0 ? (
                                        <License license={this.state.licenseData} deleteLicense={this.handleRemoveLicense} handleShowImage={this.handleImageLicense}/>
                                    ):(
                                        <div style={{margin: '20% 0 0 40%'}}>
                                        <i className="zmdi zmdi-alert-triangle zmdi-hc-5x" style={{opacity: '0.3', marginLeft: 20}}></i>
                                        <Typography>No License Data</Typography>
                                        </div>
                                            
                                    )}
                                </Grid>
                            </Grid>
                        </TabContainer>
                        <TabContainer dir={theme.direction}>
                        <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="manufacture"
                                        label="Manufacture"
                                        type="text"
                                        onChange={(e) => this.setState({manufactur: e.target.value})}
                                        fullWidth
                                    />
                                    <DatePicker
                                        fullWidth
                                        clearable
                                        label="Manufacture Date"
                                        value={this.state.manufacturing_date}
                                        format="MMMM Do YYYY"
                                        onChange={(date) => this.setState({manufacturing_date: date})}
                                        animateYearScrolling={false}
                                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                    />
                                    <TextField
                    
                                        id="body_type"
                                        label="Body Type"
                                        type="text"
                                        onChange={(e) => this.setState({body_type: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="seat_capacity"
                                        label="Seat Capacity"
                                        type="number"
                                        onChange={(e) => this.setState({seat_capacity: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="color"
                                        label="Color"
                                        type="text"
                                        onChange={(e) => this.setState({color: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="chasis_no"
                                        label="Chasis No"
                                        type="text"
                                        onChange={(e) => this.setState({chasis_no: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="payload"
                                        label="Payload"
                                        type="text"
                                        onChange={(e) => this.setState({payload: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">g</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    {/* <DatePicker
                                        fullWidth
                                        clearable
                                        label="Period STNK"
                                        value={birthDriver}
                                        format="MMMM Do YYYY"
                                        onChange={this.handleDateChange}
                                        animateYearScrolling={false}
                                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                    />
                    
                                    */}
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                    
                                        id="axle_weight"
                                        label="Axle Weight"
                                        type="number"
                                        onChange={(e) => this.setState({axle_weight: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">g</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <DatePicker
                                        fullWidth
                                        clearable
                                        label="Purchase Date"
                                        value={this.state.purchase_date}
                                        format="MMMM Do YYYY"
                                        onChange={(date) => this.setState({purchase_date: date})}
                                        animateYearScrolling={false}
                                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                    />
                                    <TextField
                    
                                        id="purchase_from"
                                        label="Purchase From"
                                        type="text"
                                        onChange={(e) => this.setState({purchase_from: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        margin="dense"
                                        id="purchase_price"
                                        label="Purchase Price"
                                        type="number"
                                        onChange={(e) => this.setState({purchase_price: e.target.value})}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">Rp</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="max_speed"
                                        label="Max Speed"
                                        type="number"
                                        onChange={(e) => this.setState({max_speed: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">km/h</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="min_speed"
                                        label="Min Speed"
                                        type="number"
                                        onChange={(e) => this.setState({min_speed: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">km/h</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                    
                                        id="idle_time"
                                        label="Idle Time"
                                        type="number"
                                        onChange={(e) => this.setState({idle_time: e.target.value})}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">s</InputAdornment>
                                        }}
                                        fullWidth
                                    />
                                    <TextField
                                        id="description"
                                        label="Description"
                                        type="text"
                                        onChange={(e) => this.setState({description: e.target.value})}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </TabContainer>
                        
                    </SwipeableViews>
                </div>
                </div>
                    
                </Dialog>
            </div>
      );
  }
}


DialogAdd.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles, { withTheme: true })(DialogAdd);


// WEBPACK FOOTER //
// ./app/routes/MasterVehicle/DialogAdd.js